/**
 * Index filtering — the `idx` URL param applied to a row set (plan §3.3).
 *
 * `ALL` is a FILTER, not a membership code (contracts/enums.ts), so it is the
 * identity case here rather than a value to look up in `idx`. Returns a NEW
 * array in every branch, including the identity one: handing the caller's own
 * array back for `ALL` would make `filterUniverse(...).sort()` reorder the
 * frozen universe for every other caller.
 */
import type { FilterKey, IndexCode } from '@meridian/contracts';

export interface IndexedRow {
  readonly idx: readonly IndexCode[];
}

export function filterUniverse<T extends IndexedRow>(
  rows: readonly T[],
  filter: FilterKey,
): readonly T[] {
  if (filter === 'ALL') return [...rows];
  return rows.filter((r) => r.idx.includes(filter));
}
